const SgiTooltipEO = () => ({
    te: "提示",
    desId: "EP_EO_UI_4008"
})

export { SgiTooltipEO };
export default SgiTooltipEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTooltipEO.js